var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldSecurityUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.51 2.24c-.83-.31-2.19-.31-3.02 0L5.5 4.11c-1.15.43-2.09 1.79-2.09 3.01v7.43c0 1.18.78 2.73 1.73 3.44l4.3 3.21c1.41 1.06 3.73 1.06 5.14 0l4.3-3.21c.95-.71 1.73-2.26 1.73-3.44V7.12c-.02-1.22-.96-2.58-2.11-3.01l-4.99-1.87zm.56 6.93c0 1.16-.91 2.09-2.06 2.13h-.1c-1.2-.04-2.1-.97-2.1-2.13-.01-1.18.95-2.14 2.12-2.14 1.18 0 2.14.96 2.14 2.14zM12 16.97c-.79 0-1.59-.2-2.19-.61-.57-.38-.88-.9-.89-1.47 0-.56.32-1.1.89-1.48 1.21-.8 3.18-.8 4.39 0 .57.38.89.9.89 1.47-.01.56-.33 1.1-.9 1.48-.61.4-1.4.61-2.19.61z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSecurityUser);
export default __webpack_public_path__ + "static/media/vuesax-bold-security-user.884069350c7abb20031bc179db35112d.svg";
export { ForwardRef as ReactComponent };